$.ready(function() {
	game.dimensions.width  = 1920;
	game.dimensions.height = 1080;

	game.panel.buildHelp(9);

	game.sounds.loadSounds({
		konami_bell: require('../sounds/FeatureTrigger.mp3'),
		bell: require('../sounds/FeatureTrigger.mp3'),
		trigger: require('../sounds/bell.mp3'),

		five_win: require('../sounds/5win.mp3'),
		drop: {
			'0': [ null, null, null, null, null ],
			'12': [
				require('../sounds/drop/12/ScatterOrchHit01.mp3'),
				require('../sounds/drop/12/ScatterOrchHit02.mp3'),
				require('../sounds/drop/12/ScatterOrchHit03.mp3'),
				require('../sounds/drop/12/ScatterOrchHit04.mp3'),
				require('../sounds/drop/12/ScatterOrchHit05.mp3') ],
		},
		reel: [
			require('../sounds/reel/reel.mp3'),
			require('../sounds/reel/reel.mp3'),
			require('../sounds/reel/reel.mp3'),
			require('../sounds/reel/reel.mp3'),
			require('../sounds/reel/reel.mp3') ],
		reel_start: require('../sounds/reel_start.mp3'),
		buttons: {
			denoms: {
				denom_0: require('../sounds/buttons/denoms/denom-12.mp3'),
				denom_1: require('../sounds/buttons/denoms/denom-11.mp3'),
				denom_2: require('../sounds/buttons/denoms/denom-10.mp3'),
				denom_3: require('../sounds/buttons/denoms/denom-9.mp3'),
				denom_4: require('../sounds/buttons/denoms/denom-8.mp3'),
				denom_5: require('../sounds/buttons/denoms/denom-7.mp3'),
				denom_6: require('../sounds/buttons/denoms/denom-6.mp3'),
			},
			coins: {
				bet_0: require('../sounds/buttons/coins/bet-3.mp3'),
				bet_1: require('../sounds/buttons/coins/bet-2.mp3'),
				bet_2: require('../sounds/buttons/coins/bet-1.mp3'),
				bet_3: require('../sounds/buttons/coins/bet.mp3'),
				bet_4: require('../sounds/buttons/coins/bet+1.mp3'),
				bet_5: require('../sounds/buttons/coins/bet+2.mp3'),
				bet_6: require('../sounds/buttons/coins/bet+3.mp3'),
				bet_7: require('../sounds/buttons/coins/bet+4.mp3'),
				bet_8: require('../sounds/buttons/coins/bet+5.mp3'),
			},
			max: require('../sounds/buttons/max_bet.mp3'),
			sound: require('../sounds/buttons/volume.mp3'),
			help: require('../sounds/buttons/open.mp3'),
			close: require('../sounds/buttons/close.mp3'),
			next: require('../sounds/buttons/next.mp3'),
			prev: require('../sounds/buttons/prev.mp3'),
		},
		freespin: {
			x2_drop: require('../sounds/freespin/2XMulti.mp3'),
			x3_drop: require('../sounds/freespin/345XAddMulti.mp3'),
			freegames: require('../sounds/freespin/freegames.mp3'),
			anticipate: [
				require('../sounds/freespin/anticipate/L585MLA_SpinMelodyR2.mp3'),
				require('../sounds/freespin/anticipate/L585MLA_SpinMelodyR3.mp3'),
				require('../sounds/freespin/anticipate/L585MLA_SpinMelodyR4.mp3') ],
			hyperdrive: require('../sounds/freespin/L585MLA_Sml_ReelSpin_Long.mp3'),
			drop: {
				'0': [
					require('../sounds/freespin/drop/0/WildStop.mp3'),
					require('../sounds/freespin/drop/0/WildStop2.mp3'),
					require('../sounds/freespin/drop/0/WildStop4.mp3'),
					require('../sounds/freespin/drop/0/WildStop4.mp3'),
					require('../sounds/freespin/drop/0/WildStop4.mp3') ],
			},
		},
		win: {
			intro1: require('../sounds/win/intro1.mp3'),
			intro2: require('../sounds/win/intro2.mp3'),
			win_1: require('../sounds/win/Level1_Hit01s.mp3'),
			win_2: require('../sounds/win/Level2_Hit06s.mp3'),
			win_3: require('../sounds/win/Level3_Hit10s.mp3'),
			bigwin_1: require('../sounds/win/Level4_Hit12s.mp3'),
			bigwin_2: require('../sounds/win/Level5_Hit17s.mp3'),
			bigwin_3: require('../sounds/win/Level6_Hit24s.mp3'),
			konami_1: require('../sounds/win/Level4_Hit12s.mp3'),
			konami_2: require('../sounds/win/Level5_Hit17s.mp3'),
			konami_3: require('../sounds/win/Level6_Hit24s.mp3'),
		},
	});

	game.panel.bigwin.levels[5][0].duration = 5;
	game.panel.bigwin.levels[5][1].duration = 12;
	game.panel.bigwin.levels[5][2].duration = 15;

	var isWild = false;
	var num_wilds = 0;
	var fireworks_timeout;
	var panel_rollup_delay;
	// var decor_delay;

	var game_delays = [];
	var wild_drops  = [];
	var win_5s 		= [];
	var dropped     = [ [], [], [], [], [] ];
	var total_delay = 0;
	var gameSet = false;

	/* For reel background*/
	var reels = $.div('reels');
	reels.prependTo(game.container);

	game.fire_holder = $.div('fireworks').appendTo(game.container);
	game.cel_holder = $.div().addClass('div-crop').appendTo(game.fire_holder);
	game.celebration = $.div('celebration').addClass('').appendTo(game.cel_holder);
	// game.celebration = $.div('celebration').addClass('animate').appendTo(game);

	var actionLogo = $.div('action-logo');
	actionLogo.appendTo(game.container);

	var win_message_holder = $.div('win_message_holder');
	win_message_holder.appendTo(game.container);
	var win_holder = $.div().addClass('div-crop').appendTo(win_message_holder);
	var win_message = $.div('win_message');
	win_message.appendTo(win_holder);

	var freespin = game.features.freespin = game.generateFreespin({ symbol: 12, introTime: 4000, outroTime: 1, triggerTime: 4500 });

	game.specials = {
		0: { reels: [ 0, 1, 2, 3, 4 ], min: 1, needs: 1, ignoreSequential: true },
		12: { reels: [ 0, 1, 2, 3, 4 ], min: 2, needs: 3, anticipate: false },
	};

	game.on('ready', function() {
		gameSet = true;
	});

	game.panel.bigwin.celebrations = {};

	game.on('ui', function() {
		setTimeout(function() {
			game.sounds.sounds.bell = game.sounds.sounds.konami_bell;
		}, 100);
	});
	// {Firework animation
	freespin.on('begin', function() {
		this.play.message.html('Press to Start');
	});

	game.on('round_complete', function() {
		game.celebration.removeClass('animate');
		game.fire_holder.removeClass('animate');
		clearTimeout(fireworks_timeout);
	});

	game.panel.spin.on('click', function() {
		clearTimeout(fireworks_timeout);
		if (game.celebration.hasClass('animate')) {
			game.celebration.removeClass('animate');
			game.fire_holder.removeClass('animate');
		}
	});
	// }

	// {freespin bonus
	freespin.on('begin', function() {
		game.sounds.sounds.drop[0] = game.sounds.sounds.freespin.drop[0];
		game.sounds.play('trigger');
	});

	freespin.on('finish', function() {
		for (var reel = 0; reel < game.frame.reels.length; reel++) {
			game.frame.reels[reel].attr('class', 'reel reel-' + reel);
		}
		game.sounds.sounds.drop[0] = [ null, null, null, null, null ];
		// game.panel.disabled = false;
	});

	freespin.methods.finish = function(response, recall) {
		// needed to be overwritten since the outro message isn't actually shown
		freespin.trigger('finish', { recall: recall });

		game.removeClass('w_p');
		game.messaging.hide();
		game.messaging.show('logo');

		freespin.playing.remove();

		game.features.freespin.total.remove();

		freespin.addClass('final');
		freespin.removeClass('spinning');

		game.sounds.fade([ freespin.key, 'background' ], 1, 0, 0.5);
		game.sounds.play([ freespin.key, 'outro' ]);

		if (game.panel.type === 'mobile') {
			game.panel.spin.css('display', null);
			freespin.spins.remove();
		}

		if (recall) {
			return;
		}
		game.panel.disabled = true;
		setTimeout(function() {
			game.feature.finish();
		}, (freespin.config.outroTime));
		setTimeout(function() {
			// game.panel.disabled = false;
		}, 8000);
	};
	// }

	// {replace feature
	game.on('spin_init', function(e) {
		this.spindle.attr('class', 's' + this.last.replace);

		while (game_delays.shift()) {}

		if (game.feature.active === 'freespin') {
			game.addClass('w_p');
		}
		else {
			game.removeClass('w_p');
		}
		num_wilds = 0;
		game.last.delayWin = 0;

		dropWilds(true);
	});
	// }

	game.on('spin_pre_done', function() {
		// dropWilds is called on spindle animationstart
		// addDropWilds adds winning drops to array
		addDropWilds();
		// checklines looks for 5win
		checkLines(true);
		// Figure out which intro to be played and how long to deal
		var level = (game.last.win / game.panel.denom.get()) / game.panel.coins.get();
		// winsound plays intro and decor, and determines fireworks
		winSound(level);

		if (!(game.feature.active === 'freespin')) {
			// Show more freespins, message
			if (game.last.scatters.counts[12] > 2) {
				game.messaging.hide('logo');
			}
		}
		else {
			if (game.last.scatters.counts[12] > 1 && !num_wilds) {
				game.last.retriggered = true;
			}
		}
	});

	game.on('spin_done', function() {
		if (game.feature.active === 'freespin') {
		// Show more freespins, message
			if (game.last.scatters.counts[12] > 1 && !num_wilds) {
				game.last.retriggered = true;
				game.retriggerFreegamesBanner();
			}
		}

		if (gameSet) {
			nextGameDelay();
		}
	});

	game.retriggerFreegamesBanner = function() {
		if (game.last.scatters.counts[12] > 1) {
			game.last.retriggered = true;
			setTimeout(function() {
				game.feature.showMessage('intro_' + game.last.scatters.counts[12], '', true);
				game.feature.messages.addClass('hide');
				game.panel.removeClass('hide');
				game.panel.show(true);
				var moreSpins = 1500;
				if (!game.sounds.fallback || (game.sounds.fallback && !game.last.win)) {
					game.sounds.play([ 'freespin', 'freegames' ], { gain: .787 });
				}
				setTimeout(function() {
					game.feature.hideMessages();
				}, freespin.config.triggerTime - 1750);
			}, 1250);
		}
	};

	game.on('multiplierRevealDone!', function() {
		setTimeout(function() {
			game.retriggerFreegamesBanner();
		}, 150);
	});

	function winSound(level) {
		var intro_sound;
		var intro_num = 0;
		// var decor = 0;

		if (level >= 2000) {
			// decor = 1;
			intro_num = 2;
		}
		else if (level >= 1000) {
			intro_num = 1;
		}
		else if (level >= 700) {
			intro_num = 1;
		}

		// play intro, game.last.delayWin is set by 5win and freegame wild drops
		var use_this = 0;
		var factor = 0;
		if (game.last && game.last._cost) {
			factor = game.last.win / (game.last._cost);
		}
		else if (game.old && game.old._cost) {
			factor = game.last.win / (game.old._cost);
		}
		for (use_this = 0; use_this < game.panel.bigwin.breakpoints.length; use_this++) {
			if (factor < game.panel.bigwin.breakpoints[use_this]) {
				break;
			}
		}

		if (intro_num) {
			addGameDelay({ type: 'sounds', intro_num: intro_num, decor: 0 }, 1);
		}
		if (use_this >= 5) {
			addGameDelay({ type: 'fireworks', intro: intro_num }, 1);
		}
	}

	function removeIntro(symbol, time) {
		setTimeout(function() {
			symbol.removeClass('intro');
		}, time);
	}

	function checkLines(add) {
		if (!game.last) { return false; }
		var lines = game.last.lines;
		var line;
		var _5win = [];
		var temp;
		var glow_delay = 0;
		var toggle_delay = 0;

		// game.pays.clear(true, true);
		// 5 wins don't trigger on royals
		var blacklist = [ 6, 7, 8, 9, 10, 11, 12 ];
		var passed = false;

		if (game.last.win < game.last._cost * 5) { return; }
		if (game.old && game.last.win < game.old._cost * 5) { return; }
		if (!(game.last || game.old)) { return; }

		for (line in lines.pays) {
			if (lines.pays[line][1] === 5) {

				// 5win
				temp = game.config.lines.lines[lines.pays[line][0]];

				// check blacklist
				for (var reel in game.frame.reels) {
					if ((blacklist.indexOf(game.last.matrix[reel][temp[reel]]) > -1)) {
						passed = false;
						break;
					}
					else { passed = true; }
				}

				// show blue frame
				if (passed) {
					// if (!(_.contains(_5win, game.config.lines.lines[lines.pays[line][0]]))){

					_5win.push(game.config.lines.lines[lines.pays[line][0]]);
					// }
					glow_delay = 4000;
				}
			}
		}
		win_5s = _5win;

		if (glow_delay && add) {
			addGameDelay({ type: '5win' }, glow_delay);
		}

		return glow_delay;// + toggle_delay;
		// return game.last.delayWin;
	}

	function toggleSymbols(_5win, add) {
		for (var line in _5win) {
			for (var reel in game.frame.reels) {
				if (add) {
					game.frame.reels[reel].symbols[_5win[line][reel]].addClass('_5win');
					game.spindle.reels[reel].window.symbols[_5win[line][reel]].addClass('_5win');
				}
				else {
					game.frame.reels[reel].symbols[_5win[line][reel]].removeClass('_5win');
					game.spindle.reels[reel].window.symbols[_5win[line][reel]].removeClass('_5win');
				}
			}
		}
	}

	function dropWilds(add) {
		var lines = game.last.lines;
		var line;
		var reel_used = [ false, false, false, false, false ];

		for (var line in lines.pays) {
			// 5win
			var temp = game.config.lines.lines[lines.pays[line][0]];

			// check blacklist
			for (var reel in game.frame.reels) {
				if (game.last.matrix[reel][temp[reel]] === 0) {
					if (add) {
						reel_used[reel] = true;
						game.spindle.reels[reel].window.symbols[temp[reel]].addClass('symbol-0 loop');
						game.frame.reels[reel].symbols[temp[reel]].addClass('loop');
						isWild = true;
					}
					else {
						game.frame.reels[reel].symbols[temp[reel]].removeClass('loop');
						game.spindle.reels[reel].window.symbols[temp[reel]].removeClass('loop');
					}
				}
			}
		}

		var num_used = 0;
		for (var r in reel_used) {
			if (reel_used[r]) {
				if (add) {
					num_used += 1000;
				}
				num_wilds++;
			}
		}

		if (num_used) {
			addGameDelay({ type: 'wilds' }, num_used);
		}
	}

	function addGameDelay(type, time) {
		game_delays.push({ data: type, time: time });
		game.last.delayWin += time;
	}

	function nextGameDelay(config) {

		var next_delay = game_delays.shift();

		if (!config) {
			config = {
				intro: 0,
			};
		}

		if (next_delay) {
			delayDisplay(next_delay);

			// nextGameDelay();

			return true;
		}

		// end of delays
		// continue on with displaying wins

		dropWilds(false);

		isWild = false;
		if (game.last.delayWin && !config.intro) {
			game.pays.show();
		}
		var level = (game.last.win / game.panel.denom.get()) / game.panel.coins.get();

		if (!(game.feature.active == 'freespin')) {
			game.panel.disabled = false;
		}
		freespin.ready = true;

		if (game.last.win && game.last.delayWin) {
			// panel_rollup_delay = setTimeout(function(){
			game.last.delayWin = false;

			setTimeout(function() {
				game.panel.setWin(game.last.win);
			}, 0);
			// }, level >= 700 ? 2000 : 1);
		}
		setTimeout(function() {
			revealMissed();
		}, 500);

		return false;
	}

	var playing_ant = false;

	function delayDisplay(next) {
		var config = next.data ? next.data : {};
		if (!config.type) {
			config.type = next;
		}

		switch (config.type) {
			case '5win':
				win_message_holder.addClass('show');
				win_message.addClass('animate');
				game.sounds.play('five_win');

				toggleSymbols(win_5s, true);

				game.panel.disabled = true;

				setTimeout(function() {
					checkLines(false);
					win_message.removeClass('animate');
					win_message_holder.removeClass('show');

					toggleSymbols(win_5s, false);

					nextGameDelay();
				}, 4000);
				return;
			case 'fireworks':
				// plays win sounds
				nextGameDelay({ intro: 2000 });

				// delay fireworks until intro is done
				game.fire_holder.addClass('animate');
				game.celebration.addClass('animate');
				// game.panel.disabled = false;
				return;
			case 'wilds':
				var next_drop = wild_drops.shift();

				if (!playing_ant) {
					playing_ant = true;
					game.sounds.play([ 'freespin', 'hyperdrive' ]);
				}

				if ((game.feature.active === 'freespin') && next_drop) {
					showDrops(next_drop[0], next_drop[1], next_drop[2], next_drop[3]);
				}
				else {
					game.sounds.stop([ 'freespin', 'hyperdrive' ]);
					playing_ant = false;
					nextGameDelay();
				}
				return;
			case 'sounds':
				var delay_end = 2000;
				game.sounds.play([ 'win', 'intro' + config.intro_num ]);
				/*
				if (config.decor){
					decor_delay = setTimeout(function(){
						game.sounds.play(['win','decor']);
						//nextGameDelay();
					}, delay_end);
				}
				*/
				if (config.intro_num) {
					game.pays.show();
				}

				// delays firewoks and/or win sounds
				panel_rollup_delay = setTimeout(function() {
					nextGameDelay({ intro: 2000 });
				}, delay_end);

				return;
			default:
				break;
		}
	}

	function addDropWilds() {
		if (!(game.feature.active === 'freespin')) {
			return;
		}
		if (isWild) {
			game.panel.disabled = true;
			freespin.ready = false;
		}

		var freespin_set = false;

		for (var f in game.last.matrix) {

			var one_per_reel = false;

			for (var b in game.last.matrix[f]) {
				if (game.last.matrix[f][b] === 0) {
					wild_drops.push([ f * 1, b * 1, one_per_reel, game.last ]);
					dropped[f][b] = true;
					one_per_reel  = true;
					freespin_set  = true;
				}
			}
		}

		if (freespin_set) {
			// addGameDelay({type: 'wilds'}, 1);
		}
	}

	var last_reel = -1;
	var drop_playing = [ false, false, false ];

	function showDrops(f, b, one_per_reel, response) {
		game.frame.reels[f].symbols[b].attr('class', 'symbol symbol-0 intro x' + response.wild_multiplier[f][b]);
		game.spindle.reels[f].window.symbols[b].removeClass('loop');

		if (!drop_playing[f - 1]) {
			drop_playing[f - 1] = true;
			game.sounds.play([ 'freespin', 'anticipate', f - 1 ]);
		}

		var final_sym = false;

		var next_drop = wild_drops.shift();

		if (!next_drop) {
			final_sym = true;
		}
		setTimeout(function() {
			game.sounds.stop([ 'freespin', 'anticipate', f - 1 ]);

			drop_playing[f - 1] = false;

			if (!one_per_reel && isWild) {
				if (response.wild_multiplier[f][b] === 2) {
					game.sounds.play([ 'freespin', 'x2_drop' ]);
				}
				else {
					game.sounds.play([ 'freespin', 'x3_drop' ]);
				}
			}

			if (!next_drop) {
				game.sounds.stop([ 'freespin', 'hyperdrive' ]);
			}
		}, 1300);

		if (!(last_reel === -1)) {
			last_reel = f;
		}
		removeIntro(game.frame.reels[f].symbols[b], 1500);
		setTimeout(function() {
			if (next_drop) {
				last_reel = f;
				showDrops(next_drop[0], next_drop[1], next_drop[2], next_drop[3]);
			}
			else {
				game.sounds.stop([ 'freespin', 'hyperdrive' ]);
				playing_ant = false;
				dropWilds(false);
				game.trigger('multiplierRevealDone!');
				nextGameDelay();
				last_reel = -1;
			}
		}, final_sym ? 3000 : (next_drop && next_drop[0] === f ? 0 : 1000));
	}

	function revealMissed() {
		if (!(game.feature.active === 'freespin')) {
			return;
		}

		var next = wild_drops.shift();

		while (next) {
			game.frame.reels[next[0]].symbols[next[1]].attr('class', 'symbol symbol-0 x' + next[3].wild_multiplier[next[0]][next[1]]);

			next = wild_drops.shift();
		}
	}

	// {Sounds*/
	// Reel start sound
	game.controller.socket.on('spin', function(response) {
		game.sounds.play('reel_start', { gain: 0.472 });
		clearTimeout(panel_rollup_delay);
		// clearTimeout(decor_delay);
		game.celebration.removeClass('animate');
	});

	// Help screen bubbles
	var bubbles = 0;
	game.panel.dialog.pager.bubbles.on('click', function() {
		if (bubbles > game.panel.dialog._page) {
			game.sounds.play([ 'buttons', 'prev' ]);
			bubbles = game.panel.dialog._page;
		}
		else if (bubbles < game.panel.dialog._page) {
			game.sounds.play([ 'buttons', 'next' ]);
			bubbles = game.panel.dialog._page;
		}
	});

	// Help screen close
	game.panel.dialog.pager.exit.on('click', function() {
		game.sounds.play([ 'buttons', 'close' ]);
		bubbles = 0;
	});

	// Help screen right arrow click
	game.panel.dialog.pager.right.on('click', function() {
		game.sounds.play([ 'buttons', 'next' ]);
		bubbles = game.panel.dialog._page;
	});

	// Help screen left arrow click
	game.panel.dialog.pager.left.on('click', function() {
		game.sounds.play([ 'buttons', 'prev' ]);
		bubbles = game.panel.dialog._page;
	});

	// }End sounds*/
});



/** WEBPACK FOOTER **
 ** ./public-src/js/primary.js
 **/